import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';

import { dueDateConditionOptions } from 'constants/automation';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';

const TaskDueDateFilter = ({ index }) => {
  const {
    formState: { errors },
    control,
  } = useFormContext();

  return (
    <>
      <div className="me-2 filterbar-condition">
        <Controller
          name={`filters.${index}.condition`}
          control={control}
          rules={{ required: 'Condition is required' }}
          render={({ field }) => (
            <Dropdown
              options={dueDateConditionOptions}
              value={field.value}
              onChange={(e) => field.onChange(e.value)}
              placeholder="Select Condition"
              className="w-100"
              inputRef={field.ref}
            />
          )}
        />
        <RequiredValidation field={`filters.${index}.condition`} errors={errors} />
      </div>
      <div className="me-2 filterbar-value">
        <Controller
          name={`filters.${index}.value`}
          control={control}
          rules={{ required: 'Value is required' }}
          render={({ field }) => (
            <Calendar
              value={field.value?.due_date}
              onChange={(e) => field.onChange({ due_date: e.value })}
              placeholder="Select Value"
              className="input-shadow w-100"
              display="chip"
            />
          )}
        />
        <RequiredValidation field={`filters.${index}.value`} errors={errors} />
      </div>
    </>
  );
};

export default TaskDueDateFilter;
